import { render } from "./ExpenseBreakdownChart.vue?vue&type=template&id=1828aff8"
import script from "./ExpenseBreakdownChart.vue?vue&type=script&lang=js"
export * from "./ExpenseBreakdownChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__